/*
 * Barnabas Fluid — Bryhel-like prestige motion for immersive pages.
 * Lenis smooth scroll + soft cursor, magnetic CTAs, scroll reveals, pointer fields.
 * Gated for reduced-motion. Cursor/magnetics only on fine pointers.
 */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  var body = document.body;
  if (!body) return;

  var isIndex = body.classList.contains('template--index');
  var isCollection = body.classList.contains('template--collection');
  var isProduct = body.classList.contains('template--product');
  var isCulture = !!document.querySelector('.bbculture[data-header-overlap-compatible]');
  if (!isIndex && !isCollection && !isProduct && !isCulture) return;
  if (!document.querySelector('.bbw[data-header-overlap-compatible], .bbc[data-header-overlap-compatible], .bbp[data-header-overlap-compatible], .bbherb, .bbculture')) return;

  document.documentElement.classList.add('bb-fluid');
  body.setAttribute('data-bb-fluid', 'true');

  /* ---------- Lenis smooth scroll (Bryhel-style) ---------- */
  var lenis = null;
  function initLenis() {
    if (reduce.matches || typeof window.Lenis !== 'function') return;
    lenis = new window.Lenis({
      lerp: 0.085,
      wheelMultiplier: 0.92,
      touchMultiplier: 1.05,
      smoothWheel: true,
      syncTouch: false,
      autoRaf: false,
      overscroll: true
    });
    window.__bbLenis = lenis;

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    // Pause when drawers / modals open so native overlays stay usable
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('[data-drawer-open], [data-modal-open], .modal--root, .cart--root')) {
        // let native UI win briefly
      }
    }, true);

    var drawerObserver = new MutationObserver(function () {
      var open = document.documentElement.getAttribute('aria-busy') === 'true'
        || document.body.classList.contains('drawer--open')
        || document.querySelector('[aria-expanded="true"][data-drawer-view], .modal--root[aria-hidden="false"]');
      if (!lenis) return;
      if (open) lenis.stop();
      else lenis.start();
    });
    drawerObserver.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['aria-expanded', 'aria-hidden', 'class'] });
  }
  initLenis();

  /* ---------- Soft cursor trail (desktop only) ---------- */
  if (fine.matches && !reduce.matches) {
    var trail = document.createElement('div');
    trail.className = 'bb-fluid-cursor';
    trail.setAttribute('aria-hidden', 'true');
    trail.innerHTML = '<i class="bb-fluid-cursor__core"></i><i class="bb-fluid-cursor__ring"></i>';
    document.body.appendChild(trail);

    var mx = window.innerWidth / 2;
    var my = window.innerHeight / 2;
    var cx = mx;
    var cy = my;
    var rx = mx;
    var ry = my;

    function cursorFrame() {
      cx += (mx - cx) * 0.16;
      cy += (my - cy) * 0.16;
      rx += (mx - rx) * 0.07;
      ry += (my - ry) * 0.07;
      trail.style.setProperty('--x', cx.toFixed(1) + 'px');
      trail.style.setProperty('--y', cy.toFixed(1) + 'px');
      trail.style.setProperty('--rx', rx.toFixed(1) + 'px');
      trail.style.setProperty('--ry', ry.toFixed(1) + 'px');
      requestAnimationFrame(cursorFrame);
    }
    requestAnimationFrame(cursorFrame);

    window.addEventListener('pointermove', function (e) {
      mx = e.clientX;
      my = e.clientY;
      trail.classList.add('is-on');
    }, { passive: true });
    window.addEventListener('pointerdown', function () { trail.classList.add('is-press'); });
    window.addEventListener('pointerup', function () { trail.classList.remove('is-press'); });
    document.addEventListener('mouseleave', function () { trail.classList.remove('is-on'); });

    document.addEventListener('pointerover', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('a, button, .bbw__flowerBtn, .bbw__cta, .bbherb__item, .bbfe__card, .bbherb__cta, .bbp__navBtn, .bbc__card')) {
        trail.classList.add('is-hot');
      }
    }, true);
    document.addEventListener('pointerout', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('a, button, .bbw__flowerBtn, .bbw__cta, .bbherb__item, .bbfe__card, .bbherb__cta, .bbp__navBtn, .bbc__card')) {
        trail.classList.remove('is-hot');
      }
    }, true);
  }

  /* ---------- Magnetic CTAs ---------- */
  if (fine.matches && !reduce.matches) {
    function initMagnetic(el) {
      var strength = parseFloat(el.getAttribute('data-bb-magnet')) || 18;
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var dx = (e.clientX - (r.left + r.width / 2)) / (r.width / 2);
        var dy = (e.clientY - (r.top + r.height / 2)) / (r.height / 2);
        el.style.transform = 'translate3d(' + (dx * strength).toFixed(1) + 'px,' + (dy * strength).toFixed(1) + 'px,0)';
      });
      el.addEventListener('pointerleave', function () {
        el.style.transform = '';
      });
    }
    document.querySelectorAll('[data-bb-magnet], .bbw__cta, .bbherb__cta, .bbc__cta').forEach(initMagnetic);
  }

  /* ---------- Cinematic scroll reveals ---------- */
  var revealEls = document.querySelectorAll(
    '[data-bb-reveal], .bbherb, .bbfe, .bbc, .bbp__story, .bbp__related, .bbherb__copyCol, .bbherb__item, .bbfe__card, .bbc__card'
  );
  if (!reduce.matches && 'IntersectionObserver' in window && revealEls.length) {
    var rio = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = el.getAttribute('data-bb-delay');
        if (delay) el.style.transitionDelay = delay;
        el.classList.add('is-inview');
        rio.unobserve(el);
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -10% 0px' });
    revealEls.forEach(function (el, i) {
      el.classList.add('bb-reveal');
      if (!el.getAttribute('data-bb-delay') && (el.classList.contains('bbherb__item') || el.classList.contains('bbfe__card') || el.classList.contains('bbc__card'))) {
        el.setAttribute('data-bb-delay', (i % 3) * 0.08 + 's');
      }
      rio.observe(el);
    });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-inview'); });
  }

  /* ---------- Hero panel field ---------- */
  document.querySelectorAll('.bbw__panel').forEach(function (panel) {
    panel.addEventListener('pointerenter', function () {
      panel.classList.add('is-focus');
      var root = panel.closest('.bbw');
      if (root) root.classList.add('has-focus');
    });
    panel.addEventListener('pointerleave', function () {
      panel.classList.remove('is-focus');
      var root = panel.closest('.bbw');
      if (root && !root.querySelector('.bbw__panel.is-focus')) root.classList.remove('has-focus');
    });
  });

  /* ---------- Section pointer fields ---------- */
  function initField(root, selector) {
    if (!root || !fine.matches || reduce.matches) return;
    var items = root.querySelectorAll(selector);
    root.addEventListener('pointermove', function (e) {
      var r = root.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width - 0.5;
      var py = (e.clientY - r.top) / r.height - 0.5;
      root.style.setProperty('--bb-field-x', px.toFixed(3));
      root.style.setProperty('--bb-field-y', py.toFixed(3));
    });
    root.addEventListener('pointerleave', function () {
      root.style.setProperty('--bb-field-x', '0');
      root.style.setProperty('--bb-field-y', '0');
    });
    items.forEach(function (item, i) {
      item.setAttribute('data-bb-depth', String((i % 3) + 1));
      item.addEventListener('pointermove', function (e) {
        var r = item.getBoundingClientRect();
        var dx = (e.clientX - (r.left + r.width / 2)) / r.width;
        var dy = (e.clientY - (r.top + r.height / 2)) / r.height;
        item.style.setProperty('--bb-tilt-x', (dy * -8).toFixed(2) + 'deg');
        item.style.setProperty('--bb-tilt-y', (dx * 10).toFixed(2) + 'deg');
        item.style.setProperty('--bb-lift', '1');
      });
      item.addEventListener('pointerleave', function () {
        item.style.setProperty('--bb-tilt-x', '0deg');
        item.style.setProperty('--bb-tilt-y', '0deg');
        item.style.setProperty('--bb-lift', '0');
      });
    });
  }

  initField(document.querySelector('.bbherb'), '.bbherb__item');
  initField(document.querySelector('.bbfe'), '.bbfe__card');
  initField(document.querySelector('.bbc'), '.bbc__card');

  /* ---------- Scroll progress for ambient section shifts ---------- */
  var sections = document.querySelectorAll('.bbw, .bbherb, .bbfe, .bbc, .bbp');
  function onScroll() {
    var vh = window.innerHeight || 1;
    sections.forEach(function (sec) {
      var r = sec.getBoundingClientRect();
      var p = 1 - Math.min(1, Math.max(0, r.top / vh));
      sec.style.setProperty('--bb-scroll', p.toFixed(3));
      var mid = (r.top + r.height * 0.35) / vh;
      var drift = Math.max(-1, Math.min(1, 1 - mid));
      sec.style.setProperty('--bb-drift', drift.toFixed(3));
    });
  }

  function bindScroll() {
    if (lenis) {
      lenis.on('scroll', onScroll);
    } else {
      window.addEventListener('scroll', function () {
        requestAnimationFrame(onScroll);
      }, { passive: true });
    }
    onScroll();
  }
  bindScroll();
})();
